<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profileparameter.parameters')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileParameterForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ProfileParameterForm from '../../components/profileparameter/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ProfileParameter';

const { mapFields } = createHelpers({
  getterType: 'profileparameter/getField',
  mutationType: 'profileparameter/updateField'
});

export default {
  name: 'ProfileParameterCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileParameterForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('profileparameter', ['create', 'reset'])
  }
};
</script>
